import React, { Fragment, useState } from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Header, Dropdown, Icon } from 'semantic-ui-react';
import i18next from 'i18next';
import AppContainer from '../app-container/AppContainer';
import LoyaltyMenuItems from './LoyaltyMenuItems';
import SubContainer from '../app-container/SubContainer';
import { hasLoyaltyPermission } from '../../helpers/permissions';

const LoyaltyContainer = ({ children, ...props }) => {
    const loyaltyPrograms = useSelector(state => state.loyaltyApp.loyaltyPrograms);
    const [pickerValue, setPickerValue] = useState('');

    const { loyaltyProgramId } = props.match.params;
    const currentLoyalty = loyaltyPrograms.find(c => c.id == loyaltyProgramId);
    
    function renderPicker(customTrigger) {
        const options = loyaltyPrograms.map(c => ({
            key: c.id,
            value: c.id,
            text: c.name,
            as: Link,
            to: `/loyaltyProgram/${c.id}`,
        }));
        const value = loyaltyProgramId;

        function renderCustomTrigger() {
            if (customTrigger) {
                return (
                    <Fragment>
                        <div style={{ display: pickerValue ? 'none' : 'flex', color: '#a7a7a7', marginBottom: -15 }}>
                            <Icon name='search' style={{ fontSize: 14 }} /> {i18next.t('switchLoyalty')}
                        </div>
                        <Header size='large'>
                            <Header.Content>
                                {currentLoyalty.name}
                                <Header.Subheader>{'loyalty program'}</Header.Subheader>
                            </Header.Content>
                        </Header>
                    </Fragment>
                );
            }
        }

        return (
            <Dropdown
                trigger={renderCustomTrigger()}
                options={options}
                value={value}
                fluid
                item
                search
                placeholder="search"
                icon={null}
                onSearchChange={(e, { searchQuery }) => setPickerValue(searchQuery)}
            />
        );
    }

    function renderMenuItems(iconOnly) {
        return <LoyaltyMenuItems iconOnly={iconOnly} loyaltyProgramId={loyaltyProgramId} {...props} />;
    }

    if (!hasLoyaltyPermission()) {
        return <Redirect to={{ pathname: '/' }} />;
    }

    if (!currentLoyalty) return <AppContainer {...props}>{children}</AppContainer>;

    return (
        <SubContainer
            renderPicker={renderPicker}
            renderMenuItems={renderMenuItems}
            menuItemsCount={6}
            {...props}
        >
            {children}
        </SubContainer>
    );
};

LoyaltyContainer.propTypes = {
    children: PropTypes.any,
    
    match: PropTypes.object
};

export default LoyaltyContainer;
